export default () => `
  <div class="content">
  Longest Building Length may effect wind loads and the allowable height of the building. 
  </div>
`;
